import React, { useEffect, useMemo, useState } from 'react'
import { Col, Container, Form, Row } from 'react-bootstrap';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar'
import HomeTitle from '../components/HomeTitle/HomeTitle'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Select from "react-select";
import axios from 'axios';
import CustomBtn from '../components/CustomBtn/CustomBtn';
import { toast, ToastContainer } from 'react-toastify';
  const CustomInput = ({ name, value, onChange, type = "text", placeholder }) => (
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className='form-control bg-light border-0 rounded-3 mb-3'
      style={{ height: '50px' }}
      placeholder={placeholder}
    />
  );
function EditeStudent() {
  const { id } = useParams();
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state.auth?.userArray?.user);
  const { list: items } = useSelector((state) => state.Students);
  const { stgeesArray } = useSelector((state) => state.stages);

  const merged = [
    ...items.recently_created_students,
    ...items.student_expenses.data
  ];


  const student = merged.find((item) => {
    if (item.student) {
      return item.student.id == id
    } else {
      return item.id == id
    }
  })


  const token = useSelector((state) => state.auth?.userArray.access_token);
  const stgeesArrayData = useSelector((state) => state.stages);

  const studentDataObj = student?.student ? student?.student : student;
  const stageData = stgeesArrayData?.stgeesArray.map(item => ({
    value: item.id,
    label: item.name
  }));
  /*******************Inputs data **********************/
  const [studentData, setStudentData] = useState({
    civilId: studentDataObj?.identity_number, name: studentDataObj?.name, nameEn: studentDataObj?.name_en, gender: student?.female?.gender == "m" ? currentLocal.home.male : currentLocal.home.male, siblingCount: '', siblingOrder: ''
  });

  const [fatherData, setFatherData] = useState({
    name: studentDataObj?.parent?.parent_name, nationality: studentDataObj?.parent?.parent_nationality, civilId: studentDataObj?.parent?.parent_identity_number, phone: studentDataObj?.parent_phone, job: studentDataObj?.parent?.parent_job, workplace: studentDataObj?.parent?.parent_job_address, educationLevel: studentDataObj?.parent?.parent_education_level,
  });
  const [motherData, setMotherData] = useState({
    name: studentDataObj?.parent?.mother_name, nationality: studentDataObj?.parent?.mother_nationality, civilId: studentDataObj?.parent?.mother_identity_number, phone: studentDataObj?.parent?.mother_phone, job: studentDataObj?.parent?.mother_job, workplace: studentDataObj?.parent?.mother_job_address, educationLevel: studentDataObj?.parent?.mother_education_level,
  });


  const [relativeData, setRelativeData] = useState({
    name: "", relationship: "", phone: "",
  });
  const [addressData, setAddressData] = useState({
    streetNumber: student?.student ? studentDataObj?.street_number : "",
    houseNumber: student?.student ? studentDataObj?.house_number : "",
    nearestPlace: student?.student ? studentDataObj?.nearest_landmark : "",
    mapLink: student?.student ? studentDataObj?.home_location_url : "",
    governorates: ""
  });

  const [selectedDate, setSelectedDate] = useState(studentDataObj?.birth_date);
  const [stageId, setStageId] = useState(null)
  const [categoriesstageId, setCategoriesstageId] = useState(null)
  const [optionsState, setOptionsState] = useState([])
  const [categoriesStage, setCategoriesStage] = useState([])
  const [governoratId, setgovernoratId] = useState(student?.student ? studentDataObj?.region?.state?.governorate?.id : "")
  const [stateId, setstateId] = useState(student?.student ? studentDataObj?.region?.state?.id : "")
  const [regionId, setregionId] = useState(student?.student ? studentDataObj?.region?.id : "")
  const [statesState, setstatesState] = useState([])
  const [governoratesState, setgovernoratesState] = useState([])
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [regionsState, setregionsState] = useState([])
  const [loading, setLoading] = useState(false);

  const [transportType, setTransportType] = useState(student?.student ? studentDataObj?.transport : "school_bus");
  const [speech, setSpeech] = useState("excellent");
  const [parentStatus, setParentStatus] = useState("together");
  const [healthData, setHealthData] = useState({
    chronic: "", // يعاني من أمراض مزمنة
    allergy: "", // لديه حساسية من وجبة معينة
    notes: "", // ملاحظات صحية أخرى
  });
  
  const [educationalData, setEducationalData] = useState({
    skills: "", // مهارات مميزة للطالب
    prevStudy: '', // هل سبق له الدراسة؟
    prevSchoolData: "", // بيانات المدرسة السابقة
    recognizeLetters: "", // هل يميز الحروف بشكل عشوائي؟
    shortRead: "", // يقرأ كلمات قصيرة
    longRead: "", // يقرأ جمل قصيرة
    quranMemorization: "", // يحفظ سورا من القرآن
    edNotes: "", // ملاحظات تعليمية أخرى
  });

  /***********************change input *****************************/
  const handleDataChange = (e, setData) => {
    setData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleRadioChange = (e, stateKey, setState) => {
    setState((prev) => ({ ...prev, [stateKey]: e.target.value }));
  };
  const options = [
    { value: "hyperactive", label: currentLocal.home.hyperactive },
    { value: "irritable", label: currentLocal.home.irritable },
    { value: "inflexible", label: currentLocal.home.inflexible },
    { value: "introvert", label: currentLocal.home.introvert },
    { value: "shy", label: currentLocal.home.shy },
    { value: "articulate", label: currentLocal.home.articulate },
  ];

  /*******************************Input******************************/

  useEffect(() => {
    const getData = async () => {

      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/grades`, {
          headers: {


                      Authorization: `Bearer ${token}`

          }
        });


        // const filterGrades = response.data.data.data.filter((item) => {
        //   console.log(item.id, studentDataObj?.grade_id, "item.id, studentDataObj?.grade_id");
        //   return item.id == stageId?.label;
        // })



        setOptionsState(response.data.data.data);
      } catch (error) {

      } finally {
      }
      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/governorates`);

        const optionsRes = response.data.data.map(item => ({
          value: item.id,
          label: item.name
        }));

        setgovernoratesState(optionsRes);
      } catch (error) {

      } finally {
        setLoading(false);
      }

      if (governoratId) {
        try {
          const response = await axios.get(`https://nanosoft.space/taarteb/public/api/governorates/${governoratId}/states`);

          const optionsRes = response.data.data.map(item => ({
            value: item.id,
            label: item.name
          }));

          setstatesState(optionsRes);



        } catch (error) {


        } finally {
        }
      }
      if (governoratId && stateId) {
        try {
          const response = await axios.get(`https://nanosoft.space/taarteb/public/api/states/${stateId}/regions`);

          const optionsRes = response.data.data.map(item => ({
            value: item.id,
            label: item.name
          }));

          setregionsState(optionsRes);



        } catch (error) {

        } finally {
        }
      }

    }
    getData()
  }, [governoratId, stateId])
// useEffect(() => {
//                           const stages = stgeesArrayData?.stgeesArray
//                           const selectedId = studentDataObj?.grade_id
//                     setStageId(selectedId);

//                     // 1. نجيب الـ stage المختار
//                     const selectedStage = stages.find((item) => {

//                       return item.value == selectedId;
//                     });

//                     if (!selectedStage) return;

//                     // 2. نجيب الـ category بتاعه
//                     const selectedCategory = selectedStage.label;

//                     // 3. نفلتر كل العناصر اللي نفس الـ category
//                     const filteredData = optionsState.filter(
//                       item => item.category == selectedCategory
//                     );
//                                         console.log(filteredData,"selectedId");

//                     const categoriesStageData = filteredData.map((item) => ({
//                       label: item.name,
//                       value: item.id
//                     }));
//                     setCategoriesStage(categoriesStageData);

//       // let filterData = []
//       // if (id) {
//       //   console.log(studentData);

//       //   filterData = stgeesArray.filter((item) => item?.value == id)

//       // } else {
//       //   filterData = stgeesArray.filter((item) => item?.value == studentDataObj?.grade?.grade_category_id)

//       // }

// }, [])

useEffect(() => {
  if (!optionsState?.length || !stgeesArrayData) return;

  const stages = stgeesArrayData.stgeesArray;
  const selectedId = studentDataObj?.grade_id;

  setCategoriesstageId(selectedId);
  const selectedStage = optionsState.find((item) => item.id == selectedId);
  const selectedCategoryStage = stgeesArray.find((item) => item.label == selectedStage?.category);

const xx=optionsState.filter((item)=>item?.category==selectedCategoryStage?.label)
const xxxx=xx.map((item)=>({
  value:item?.id,
  label:item?.name
}))


  console.log(xx);
  console.log(selectedCategoryStage);


  

setCategoriesStage(xxxx)

  setStageId(selectedCategoryStage?.value);
  setCategoriesstageId(selectedStage?.id)
  // console.log(selectedStage,"selectedStage");
  // console.log(selectedId,"selectedStage");

  // if (!selectedStage) return;

  // const selectedCategory = selectedStage.label;

  // const filteredData = optionsState.filter(
  //   item => item.category === selectedCategory
  // );

  // const categoriesStageData = filteredData.map(item => ({
  //   label: item.name,
  //   value: item.id
  // }));

  // setCategoriesStage(categoriesStageData);

}, [optionsState, stgeesArrayData, studentDataObj]);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      direction: "rtl",
      backgroundColor: "#f7f7f7",
      border: state.isFocused ? "1px solid #ff5b8f" : "1px solid #ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #ff5b8f" : "none",
      borderRadius: "6px",
      padding: "2px",
      minHeight: "45px",
    }),
    placeholder: (provided) => ({
      ...provided,
      textAlign: "right",
      color: "#999",
    }),
    menu: (provided) => ({
      ...provided,
      direction: "rtl",
      textAlign: "right",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#ff5b8f" : state.isFocused ? "#ffe0ec" : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      cursor: "pointer",
    }),
  };


  const handleSubmit = async () => {

    setLoading(true);
    const startTime = performance.now();
    // 1. تجميع البيانات كـ JSON
    const jsonData = {
      // بيانات الطالب
      student: {
        ...studentData,
        dateOfBirth: studentDataObj?.birth_date ? studentDataObj?.birth_date : selectedDate ? selectedDate?.toISOString()?.split('T')[0] : null,
      },
      // بيانات الأبوين والأقارب
      parents: {
        father: fatherData,
        mother: motherData,
        status: parentStatus,
        relative: relativeData,
      },
      // البيانات السلوكية والتعليمية
      behavioralTraits: selectedOptions.map(option => option.value),
      educational: {
        ...educationalData,
        // سلامة النطق تم دمجها تحت Health
      },
      // البيانات الصحية
      health: {
        speech: speech,
        ...healthData,
      },
      // بيانات النقل والسكن
      transport: {
        type: transportType,
        address: addressData,
      },
      // (لا نضع الملفات هنا مباشرة)
    };

    const formDataPayload = new FormData();
    formDataPayload.append('name', studentData?.name)
    formDataPayload.append('phone', "")
    if (localStorage.getItem("type") != "admin") {
      formDataPayload.append('school_id', 3)

    }
    formDataPayload.append('name_en', studentData?.nameEn)
    // formDataPayload.append('email', "anancyahmed9700700@gmail.com")
    formDataPayload.append('identity_number', studentData?.civilId)
    formDataPayload.append('birth_date', studentDataObj?.birth_date ? studentDataObj?.birth_date : selectedDate?.toISOString()?.split('T')[0])
    formDataPayload.append('gender', studentData?.gender == "ذكر" ? "m" : "f")
    formDataPayload.append('grade_id', categoriesstageId)
    formDataPayload.append('siblings_count', studentData.siblingCount)
    formDataPayload.append('sibling_order', studentData.siblingOrder)
    // formDataPayload.append('password', studentData?.password)
    // formDataPayload.append('password_confirmation', studentData?.password_confirmation)
    formDataPayload.append('parent_name', fatherData.name)
    formDataPayload.append('parent_nationality', fatherData.nationality)
    formDataPayload.append('parent_identity_number', fatherData.civilId)
    formDataPayload.append('parent_phone', fatherData.phone)
    formDataPayload.append('parent_job', fatherData.job)
    formDataPayload.append('parent_job_address', fatherData.workplace)
    formDataPayload.append('parent_education_level', fatherData.educationLevel)
    formDataPayload.append('mother_name', motherData.name)
    formDataPayload.append('mother_nationality', motherData.nationality)
    formDataPayload.append('mother_identity_number', motherData.civilId)
    formDataPayload.append('mother_phone', motherData.phone)
    formDataPayload.append('mother_job', motherData.job)
    formDataPayload.append('mother_job_address', motherData.workplace)
    formDataPayload.append('mother_education_level', motherData.educationLevel)
    formDataPayload.append('parents_status', parentStatus)
    formDataPayload.append('branch_id', 1)
    formDataPayload.append('relative_name', relativeData.name)
    formDataPayload.append('relative_relation', relativeData.relationship)
    formDataPayload.append('relative_phone', relativeData.phone)




    jsonData.behavioralTraits.forEach((trait, index) => {
      formDataPayload.append(`behavioral_data[${index}]`, trait);
    });
    // formDataPayload.append('behavioral_data', JSON.stringify(jsonData.behavioralTraits));
    formDataPayload.append('distinguished_skills', educationalData.skills)
    if (educationalData.prevStudy) {
      formDataPayload.append('has_previous_education', educationalData.prevStudy)
    }

    formDataPayload.append('previous_school_data', educationalData.prevSchoolData)
    formDataPayload.append('can_distinguish_letters_randomly', educationalData.recognizeLetters)
    formDataPayload.append('reads_short_words', educationalData.shortRead)
    formDataPayload.append('reads_short_sentences', educationalData.longRead)
    formDataPayload.append('memorizes_quran_surahs', educationalData.quranMemorization)
    formDataPayload.append('additional_educational_notes', educationalData.edNotes)





    formDataPayload.append('pronunciation', speech)
    formDataPayload.append('chronic_diseases', healthData.chronic)
    formDataPayload.append('food_allergies', healthData.allergy)
    formDataPayload.append('other_notes', healthData.notes)



console.log(stateId,"stateId");

    formDataPayload.append('transport', transportType)
    formDataPayload.append('region_id', regionId)
    if(stateId){
    formDataPayload.append('state_id', stateId)

    }
    formDataPayload.append('street_number', addressData.streetNumber)
    formDataPayload.append('house_number', addressData.houseNumber)
    formDataPayload.append('nearest_landmark', addressData.nearestPlace)
    if(addressData.mapLink){
    formDataPayload.append('home_location_url', addressData.mapLink)
    }

    const API_URL = localStorage.getItem("type") == "admin" ? `https://nanosoft.space/taarteb/public/api/students/${id}` : `https://nanosoft.space/taarteb/public/api/students/register`;

    try {

      const response = await axios.post(API_URL, formDataPayload, {
        headers: localStorage.getItem("type") == "admin" ? {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`


        } : { "Content-Type": "multipart/form-data", },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(percent);

        },

      });
      toast.success(currentLocal.home.successMessage, { position: "bottom-right", autoClose: 3000 });


    } catch (error) {
      console.log(error);

      toast.error(error?.response?.data?.errors ? Object.values(error?.response?.data?.errors)[0][0] : error?.response?.data?.message, { position: "bottom-right", autoClose: 3000 });

      setLoading(false);
      console.log(error?.response?.data?.errors ? Object.values(error?.response?.data?.errors)[0][0] : error?.response?.data?.message);


    } finally {
      setLoading(false);
    }

  };
  return (
    <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <ToastContainer />

      <Container fluid className="px-4">
        <AuthNavbar />
        <div className="mt-4">
          {/* <HomeTitle title={currentLocal.home.students} /> */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <HomeTitle title={currentLocal.home.studentDataTitle} />


          </div>
          <div className='my-3'>
            <Row>

              <Col md={4}><label>{currentLocal.home.studentCivilId}<span className='text-danger'>{"*"}</span></label><CustomInput name="civilId" value={studentData.civilId} onChange={(e) => handleDataChange(e, setStudentData)} /></Col>
              <Col md={4}><label>{currentLocal.home.studentNameAr}<span className='text-danger'>{"*"}</span></label><CustomInput name="name" value={studentData.name} onChange={(e) => handleDataChange(e, setStudentData)} /></Col>
              <Col md={4}><label>{currentLocal.home.studentNameEn}</label><CustomInput name="nameEn" value={studentData.nameEn} onChange={(e) => handleDataChange(e, setStudentData)} /></Col>
              <Col md={3}>
                <label htmlFor="genderSelect">{currentLocal.home.gender}<span className='text-danger'>{"*"}</span></label>
                <select id="genderSelect" value={studentData.gender} name="gender" onChange={(e) => handleDataChange(e, setStudentData)} className='form-control bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>
                  <option value="ذكر">{currentLocal.home.male}</option>
                  <option value="أنثي">{currentLocal.home.female}</option>
                </select>
              </Col>
              <Col md={3}>
                <label>{currentLocal.home.birthDate} <span className='text-danger'>{"*"}</span></label>
                <div dir="rtl" style={{ textAlign: "right" }}>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MM-yyyy"
                    locale="ar"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText=""
                    className="form-control bg-light border-0 rounded-3"
                    style={{ height: '50px' }}
                  />
                </div>
              </Col>

              <Col md={3}><label>{currentLocal.home.SelectStage} <span className='text-danger'>{"*"}</span></label>
                <select
                  value={stageId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const stages = stgeesArrayData?.stgeesArray
                    setStageId(selectedId);

                    // 1. نجيب الـ stage المختار
                    const selectedStage = stages.find((item) => {

                      return item.value == selectedId;
                    });
                    if (!selectedStage) return;

                    // 2. نجيب الـ category بتاعه
                    const selectedCategory = selectedStage.label;

                    // 3. نفلتر كل العناصر اللي نفس الـ category
                    const filteredData = optionsState.filter(
                      item => item.category == selectedCategory
                    );
                    const categoriesStageData = filteredData.map((item) => ({
                      label: item.name,
                      value: item.id
                    }));
                    setCategoriesStage(categoriesStageData);
                  }}
      
                  className="form-control bg-light border-0 rounded-3 mb-3"
                  style={{ height: '50px' }}
                >
                  <option value="" disabled>
                    {currentLocal.home.SelectStage}
                  </option>

                  {stgeesArrayData?.stgeesArray.map(item => (
                    <option key={item.value} value={item.value} name={item.label}>
                      {item.label}
                    </option>
                  ))}
                </select>

              </Col>
              <Col md={3}><label>{currentLocal.home.chooseGrade} <span className='text-danger'>{"*"}</span></label>
                <select
                  value={categoriesstageId}
                  onChange={(e) => setCategoriesstageId(e.target.value)}
                  className="form-control bg-light border-0 rounded-3 mb-3"
                  style={{ height: '50px' }}
                >
                  <option value="" disabled>
                    {currentLocal.home.chooseGrade}
                  </option>

                  {categoriesStage.map(item => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>

              </Col>
              <Col md={3}><label>{currentLocal.home.siblingCount}</label><CustomInput type="number" name="siblingCount" value={studentData.siblingCount} onChange={(e) => handleDataChange(e, setStudentData)} /></Col>
              <Col md={3}><label>{currentLocal.home.siblingOrder}</label><CustomInput type="number" name="siblingOrder" value={studentData.siblingOrder} onChange={(e) => handleDataChange(e, setStudentData)} /></Col>
              {/* <Col md={3}><label>{currentLocal.home.passwordPlaceholder}<span className='text-danger'>{"*"}</span> </label><CustomInput type="number" name="password" value={studentData.password} onChange={(e) => handleDataChange(e, setStudentData)} /></Col>
              <Col md={3}><label>{currentLocal.home.Confirmpassword}<span className='text-danger'>{"*"}</span> </label><CustomInput type="number" name="password_confirmation" value={studentData.password_confirmation} onChange={(e) => handleDataChange(e, setStudentData)} /></Col> */}

            </Row>
          </div>

          <h5 className='text-danger'>{currentLocal.home.fatherDataTitle}</h5>
          <div className='my-3'>
            <Row>
              <Col md={4}><label>{currentLocal.home.fatherName}<span className='text-danger'>{"*"}</span></label><CustomInput name="name" value={fatherData.name} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
              <Col md={4}><label>{currentLocal.home.fatherNationality}<span className='text-danger'>{"*"}</span></label><CustomInput name="nationality" value={fatherData.nationality} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
              <Col md={4}><label>{currentLocal.home.fatherCivilId}<span className='text-danger'>{"*"}</span></label><CustomInput name="civilId" value={fatherData.civilId} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.fatherPhone}<span className='text-danger'>{"*"}</span></label><CustomInput name="phone" value={fatherData.phone} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.fatherJob}<span className='text-danger'>{"*"}</span></label><CustomInput name="job" value={fatherData.job} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.fatherWorkplace}<span className='text-danger'>{"*"}</span></label><CustomInput name="workplace" value={fatherData.workplace} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.fatherEducationLevel}</label><CustomInput name="educationLevel" value={fatherData.educationLevel} onChange={(e) => handleDataChange(e, setFatherData)} /></Col>
            </Row>
          </div>
          <h5 className='text-danger'>{currentLocal.home.Mothersdata}</h5>

          <div className='my-3'>
            <Row>
              <Col md={4}><label>{currentLocal.home.Mothersname} <span className='text-danger'>{"*"}</span></label><CustomInput name="name" value={motherData.name} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
              <Col md={4}><label>{currentLocal.home.Nationality}<span className='text-danger'>{"*"}</span> </label><CustomInput name="nationality" value={motherData.nationality} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
              <Col md={4}><label>{currentLocal.home.Civilnumber}<span className='text-danger'>{"*"}</span> </label><CustomInput name="civilId" value={motherData.civilId} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.Motherphonenumber}<span className='text-danger'>{"*"}</span> </label><CustomInput name="phone" value={motherData.phone} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.role}<span className='text-danger'>{"*"}</span> </label><CustomInput name="job" value={motherData.job} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.Worklocation} </label><CustomInput name="workplace" value={motherData.workplace} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
              <Col md={3}><label>{currentLocal.home.Educationallevel}</label><CustomInput name="educationLevel" value={motherData.educationLevel} onChange={(e) => handleDataChange(e, setMotherData)} /></Col>
            </Row>
          </div>
          <div className='my-3'>
            <Row>
              <Col md={3}>
                <label>{currentLocal.home.parentStatus}<span className='text-danger'>{"*"}</span></label>
                <select value={parentStatus} onChange={(e) => setParentStatus(e.target.value)} className='form-control bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>
                  <option value="together">{currentLocal.home.parentsTogether}</option>
                  <option value="separated">{currentLocal.home.parentsSeparated}</option>
                  <option value="widower">{currentLocal.home.parentsWidower}</option>
                  <option value="widow">{currentLocal.home.parentsWidow}</option>
                </select>
              </Col>
              <Col md={3}><label>{currentLocal.home.relativeName}</label><CustomInput name="name" value={relativeData.name} onChange={(e) => handleDataChange(e, setRelativeData)} /></Col>
              <Col md={3}><label>{currentLocal.home.relationship} </label><CustomInput name="relationship" value={relativeData.relationship} onChange={(e) => handleDataChange(e, setRelativeData)} /></Col>
              <Col md={3}><label>{currentLocal.home.relativePhone}</label><CustomInput name="phone" value={relativeData.phone} onChange={(e) => handleDataChange(e, setRelativeData)} /></Col>
            </Row>
          </div>
          <h5 className='text-danger mt-5'>{currentLocal.home.BehavioralData}</h5>
          <div >
            <label>{currentLocal.home.DistinctiveSkills}</label>
            <textarea
              rows={6}
              className='w-100 form-control bg-light border-0 rounded-3 mb-3'
              name="skills"
              value={educationalData.skills}
              onChange={(e) => handleDataChange(e, setEducationalData)}
            ></textarea>

            <label className="form-label fw-bold mb-2">{currentLocal.home.StudentBehaviors}<span className='text-danger'>{"*"}</span></label>
            <Select
              options={options}
              value={selectedOptions}
              onChange={setSelectedOptions}
              isMulti
              placeholder={currentLocal.home.Choosebehaviors}
              styles={customStyles}
              className="nice-select niceSelect w-100 bb"
            />
          </div>
          <h5 className='text-danger mt-5'>{currentLocal.home.Studenteducationaldata}</h5>
          <div >

            {/* هل سبق له الدراسة؟ */}
            <div className='d-flex align-items-center mb-3 section_container'>
              <p className='w-25 mb-0'>{currentLocal.home.studiedbefore}</p>
              <div className='mt-2'>
                <Form.Check type="radio" id="1" label={currentLocal.home.yes} name="prevStudy" value="1" checked={educationalData.prevStudy === "1"} onChange={(e) => handleRadioChange(e, "prevStudy", setEducationalData)} inline className='form-check-reverse mx-3' />
                <Form.Check type="radio" id="2" label={currentLocal.home.No} name="prevStudy" value="0" checked={educationalData.prevStudy === "0"} onChange={(e) => handleRadioChange(e, "prevStudy", setEducationalData)} inline className='form-check-reverse mx-3' />

              </div>
            </div>

            <label>{currentLocal.home.PreviousSchoolData}</label>
            <textarea
              rows={6}
              className='w-100 form-control bg-light border-0 rounded-3 mb-3'
              name="prevSchoolData"
              value={educationalData.prevSchoolData}
              onChange={(e) => handleDataChange(e, setEducationalData)}
            ></textarea>

            {/* هل يميز الحروف بشكل عشوائي؟ */}
            <div className='d-flex align-items-center mb-3 section_container'>
              <p className='w-25 mb-0'>{currentLocal.home.randomlyidentifyletters}</p>
              <div className='mt-2'>
                <Form.Check type="radio" id="3" label={currentLocal.home.yes} name="recognizeLetters" value="1" checked={educationalData.recognizeLetters === "1"} onChange={(e) => handleRadioChange(e, "recognizeLetters", setEducationalData)} inline className='form-check-reverse mx-3' />
                <Form.Check type="radio" id="4" label={currentLocal.home.No} name="recognizeLetters" value="0" checked={educationalData.recognizeLetters === "0"} onChange={(e) => handleRadioChange(e, "recognizeLetters", setEducationalData)} inline className='form-check-reverse mx-3' />
              </div>
            </div>

            {/* يقرأ كلمات قصيرة؟ */}
            <div className='d-flex align-items-center mb-3 section_container'>
              <p className='w-25 mb-0'>{currentLocal.home.readshortwords}</p>
              <Form.Check type="radio" id="5" label={currentLocal.home.Excellent} name="shortRead" value="excellent" checked={educationalData.shortRead === "excellent"} onChange={(e) => handleRadioChange(e, "shortRead", setEducationalData)} inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="6" label={currentLocal.home.Verygood} name="shortRead" value="very_good" checked={educationalData.shortRead === "very_good"} onChange={(e) => handleRadioChange(e, "shortRead", setEducationalData)} inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="7" label={currentLocal.home.Good} name="shortRead" value="good" checked={educationalData.shortRead === "good"} onChange={(e) => handleRadioChange(e, "shortRead", setEducationalData)} inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="8" label={currentLocal.home.Doesnotread} name="shortRead" value="cannot_read" checked={educationalData.shortRead === "cannot_read"} onChange={(e) => handleRadioChange(e, "shortRead", setEducationalData)} inline className='form-check-reverse mx-3' />
            </div>

            {/* يقرأ جمل قصيرة؟ */}
            <div className='d-flex align-items-center mb-3 section_container'>
              <p className='w-25 mb-0'>{currentLocal.home.readshortsentences}</p>
              <Form.Check
                type="radio"
                id="9"
                label={currentLocal.home.Excellent}
                name="longRead"
                value="excellent"
                checked={educationalData.longRead === "excellent"}
                onChange={(e) => handleRadioChange(e, "longRead", setEducationalData)}
                inline
                className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="10" label={currentLocal.home.Verygood} name="longRead" value="very_good" checked={educationalData.longRead === "very_good"} onChange={(e) => handleRadioChange(e, "longRead", setEducationalData)} inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="11" label={currentLocal.home.Good} name="longRead" value="good" checked={educationalData.longRead === "good"} onChange={(e) => handleRadioChange(e, "longRead", setEducationalData)} inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="12" label={currentLocal.home.Doesnotread} name="longRead" value="cannot_read" checked={educationalData.longRead === "cannot_read"} onChange={(e) => handleRadioChange(e, "longRead", setEducationalData)} inline className='form-check-reverse mx-3' />
            </div>

            {/* يحفظ سورا من القرآن؟ */}
            <div className='d-flex align-items-center mb-3 section_container'>
              <p className='w-25 mb-0'>{currentLocal.home.surahsfromtheQuran}</p>
              <Form.Check type="radio" id="13" label={currentLocal.home.yes} name="quranMemorization" value="1" checked={educationalData.quranMemorization === "1"} onChange={(e) => handleRadioChange(e, "quranMemorization", setEducationalData)} inline className='form-check-reverse mx-3' />
              <Form.Check type="radio" id="14" label={currentLocal.home.No} name="quranMemorization" value="0" checked={educationalData.quranMemorization === "0"} onChange={(e) => handleRadioChange(e, "quranMemorization", setEducationalData)} inline className='form-check-reverse mx-3' />
            </div>

            <Form.Group as={Col} controlId="edNotes">
              <Form.Label className='w-100'>{currentLocal.home.Othereducationalnotes}</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="edNotes"
                value={educationalData.edNotes}
                onChange={(e) => handleDataChange(e, setEducationalData)}
                className="bg-light border-0 rounded-3"
              />
            </Form.Group>
          </div>
          <div className='mt-5'>
            <h5 className='text-danger'>{currentLocal.home.Healthcondition}</h5>

            {/* سلامة النطق */}
            <div className="d-flex justify-content-start mb-4 gap-4 align-items-center form-check form-check-reverse section_container">
              <Form.Label className="fw-bold mb-0 w-25">{currentLocal.home.Pronunciationcorrectness}</Form.Label>
              <Form.Check className='p-0' id="pronunciation1" type="radio" label={currentLocal.home.Excellent} name="speech" value="excellent" checked={speech === "excellent"} onChange={() => setSpeech("excellent")} inline />
              <Form.Check className='p-0' id="pronunciation2" type="radio" label={currentLocal.home.Good} name="speech" value="good" checked={speech === "good"} onChange={() => setSpeech("good")} inline />
              <Form.Check className='p-0' id="pronunciation3" type="radio" label={currentLocal.home.Needsfollowup} name="speech" value="needs_follow_up" checked={speech === "needs_follow_up"} onChange={() => setSpeech("needs_follow_up")} inline />
            </div>

            <Form>
              <Row className="mb-3 text-end">
                <Form.Group as={Col} md="6" controlId="chronic">
                  <Form.Label className='w-100'>{currentLocal.home.chronicillnesses}<span className='text-danger'>{"*"}</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="chronic"
                    value={healthData.chronic}
                    onChange={(e) => handleDataChange(e, setHealthData)}
                    className="bg-light border-0 rounded-3"
                  />
                </Form.Group>

                <Form.Group as={Col} md="6" controlId="allergy">
                  <Form.Label className='w-100'>{currentLocal.home.particularfood}<span className='text-danger'>{"*"}</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="allergy"
                    value={healthData.allergy}
                    onChange={(e) => handleDataChange(e, setHealthData)}
                    className="bg-light border-0 rounded-3"
                  />
                </Form.Group>
              </Row>

              <Row>
                <Form.Group as={Col} controlId="notes">
                  <Form.Label>{currentLocal.home.Othernotes}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="notes"
                    value={healthData.notes}
                    onChange={(e) => handleDataChange(e, setHealthData)}
                    className="bg-light border-0 rounded-3"
                  />
                </Form.Group>
              </Row>
            </Form>
          </div>
          <div className='mt-5'>
            <h5 className='text-danger'>{currentLocal.home.Transportation}</h5>

            {/* نوع النقل */}

            <div className="d-flex justify-content-start mb-4 gap-3 form-check form-check-reverse">


              <Form.Check id="transport1" type="radio" label={currentLocal.home.Schooltransportation} name="transportType" value="school_bus" checked={transportType === "school_bus"} onChange={() => setTransportType("school_bus")} inline />
              <Form.Check id="transport2" type="radio" label={currentLocal.home.Privatetransportation} name="transportType" value="private_bus" checked={transportType === "private_bus"} onChange={() => setTransportType("private_bus")} inline />
            </div>
            <Container fluid>
              <Row>
                <Col md={4}>
                  <Form.Label>
                    {currentLocal.home.governorates}<span className='text-danger'>{"*"}</span>
                  </Form.Label>
                  <select value={governoratId} onChange={(e) => setgovernoratId(e.target.value)} className=' bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>
                    <option  >{currentLocal.home.governorates}</option>

                    {governoratesState.map((item) => {
                      return (
                        <option value={item?.value}>{item?.label}</option>

                      )
                    })}
                  </select>
                </Col>
                <Col md={4}>
                  <Form.Label>

                  </Form.Label>
                  <select value={stateId} onChange={(e) => setstateId(e.target.value)} className=' bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>
                    {statesState.map((item) => {
                      return (
                        <option value={item?.value}>{item?.label}</option>

                      )
                    })}
                  </select>
                </Col>
                <Col md={4}>
                  <Form.Group as={Col} controlId="streetNumber"><Form.Label>{currentLocal.home.region}<span className='text-danger'>{"*"}</span></Form.Label><CustomInput name="regionId" value={regionId} onChange={(e) => setregionId(e.target.value)} placeholder={currentLocal.home.region} /></Form.Group>

                </Col>
              </Row>
            </Container>



            {/* <select value={regionId} onChange={(e) => setregionId(e.target.value)} className='form-control bg-light border-0 rounded-3 mb-3' style={{ height: '50px' }}>

              {regionsState.map((item) => {
                return (
                  <option value={item?.value}>{item?.label}</option>

                )
              })}
            </select> */}



            <Form>
              <Row className="mb-3 text-end">
                <Form.Group as={Col} md="4" controlId="streetNumber"><Form.Label>{currentLocal.home.Tracknumber}</Form.Label><CustomInput name="streetNumber" value={addressData.streetNumber} onChange={(e) => handleDataChange(e, setAddressData)} /></Form.Group>
                <Form.Group as={Col} md="4" controlId="houseNumber"><Form.Label>{currentLocal.home.Housenumber}</Form.Label><CustomInput name="houseNumber" value={addressData.houseNumber} onChange={(e) => handleDataChange(e, setAddressData)} /></Form.Group>
                <Form.Group as={Col} md="4" controlId="nearestPlace"><Form.Label>{currentLocal.home.Nearestknownlocation}</Form.Label><CustomInput name="nearestPlace" value={addressData.nearestPlace} onChange={(e) => handleDataChange(e, setAddressData)} /></Form.Group>
              </Row>

              <Row>
                <Form.Group as={Col} controlId="mapLink">
                  <Form.Label>{currentLocal.home.Linklocation} (Google Maps)</Form.Label>
                  <CustomInput name="mapLink" value={addressData.mapLink} onChange={(e) => handleDataChange(e, setAddressData)} />
                </Form.Group>
              </Row>
            </Form>
          </div>
          {/* <div className='mt-5'>
          {userinfo?.role != "Student" &&
            <label className='text-danger fw-bold mb-3'>{currentLocal.home.files}</label>
          }
          {userinfo?.role != "Student" &&

            <Row>
              {rows.map((item, index) => (
                <Col md={6} key={index}>
<label className='label mb-3 mt-4'>{currentLocal.language == "العربيه" ? item.label : item.label_en}<span className='text-danger'>{item?.require&& "*"}</span></label>
                  <div className='d-flex justify-content-between mb-3 align-items-center'>
                    <label className="btn btn-pink text-white px-4">
                      {currentLocal.home.Upload}
                      <input
                        type="file"
                        onChange={(e) => handleFileChange(e, item.key)}
                        hidden
                        accept="image/*,application/pdf"
                      />
                    </label>
                    <input
                      type="text"
                      className="form-control bg-light text-end"
                      placeholder={currentLocal.language == "العربيه" ? item.label : item.label_en}
                      // عرض اسم الملف الذي تم اختياره (إذا كان موجوداً)
                      value={files[item.key] ? files[item.key].name : ""}
                      readOnly
                      style={{ width: '70%' }}
                    />
                  </div>
                </Col>
              ))}
            </Row>
          }
        </div> */}
          <Row>
            <Col md={12}>
              <div className='d-flex justify-content-center my-4 '>
                <div className='w-25 d-flex justify-content-center add_btn'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.edit} disabled={loading} clickingFunction={handleSubmit} />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>



    </div>
  )
}

export default EditeStudent